import { useEffect } from 'react';
import { notification } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const AdjudicationNotifier = ({ wsMessages }) => {
    const [notifApi, notifContextHolder] = notification.useNotification();

    useEffect(() => {
        if (!wsMessages || wsMessages.length === 0) return;

        const newMessage = wsMessages[wsMessages.length - 1];
        if (!newMessage?.ip_no || !newMessage?.status) return;

        const isEnded = newMessage.status === 'ENDED';

        notifApi[isEnded ? 'success' : 'error']({
            message: isEnded ? 'Adjudication Complete' : 'Adjudication Failed',
            description: isEnded
                ? `${newMessage.ip_no} has finished processing. Please check My Cases.`
                : `${newMessage.ip_no} encountered an error during processing. Please check My Cases.`,
            icon: isEnded
                ? <CheckCircleOutlined style={{ color: '#79A7A5' }} />
                : <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
            placement: 'topRight',
            duration: 6,
            style: {
                background: '#161C1C',
                border: '1px solid',
                borderColor: isEnded ? 'rgba(121,167,165,0.3)' : 'rgba(255,77,79,0.3)',
                borderRadius: '8px',
                color: '#F0F8F7',
            },
        });

    }, [wsMessages]);

    return notifContextHolder;
};

export default AdjudicationNotifier;